import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(({ palette }) => ({
  card: {
    position: "relative",
    borderRadius: 8,
    boxShadow: `0 8px 16px 0 ${palette.grey[300]}`,
  },
}));

export default useStyles;
